import { Command } from '../../_base/actionBus/Command';
import { Nullable } from '../../_base/lang/Nullable';
import { FileInfo } from '../../models/general/FileInfo';

export class CreateClaim extends Command {
    constructor(public subjectId: Nullable<number>, public description: string, public attachments: FileInfo[] = []) {
        super();
    }
}
